module.exports = __webpack_public_path__ + "media/IBMPlexSans-SemiBold.woff";


//////////////////
// WEBPACK FOOTER
// ./src/fonts/IBMPlexSans/IBMPlexSans-SemiBold.woff
// module id = 1471
// module chunks = 58